import { Icon } from "@iconify/react";
import "../styles/QuoteCustomerInfo.css";

function QuoteCustomerInfo({ quote }) {
  const customer = quote.customer;
  const address = quote.address;

  if (!customer) return null;

  const formatPhone = (phone) => {
    if (!phone) return "";
    const cleaned = phone.replace(/\D/g, "");
    if (cleaned.length === 11) {
      return `(${cleaned.slice(0, 2)}) ${cleaned.slice(2, 7)}-${cleaned.slice(7)}`;
    }
    if (cleaned.length === 10) {
      return `(${cleaned.slice(0, 2)}) ${cleaned.slice(2, 6)}-${cleaned.slice(6)}`;
    }
    return phone;
  };

  const formatDocument = (doc) => {
    if (!doc) return "";
    const cleaned = doc.replace(/\D/g, "");
    if (cleaned.length === 11) {
      return `${cleaned.slice(0, 3)}.${cleaned.slice(3, 6)}.${cleaned.slice(6, 9)}-${cleaned.slice(9)}`;
    }
    if (cleaned.length === 14) {
      return `${cleaned.slice(0, 2)}.${cleaned.slice(2, 5)}.${cleaned.slice(5, 8)}/${cleaned.slice(8, 12)}-${cleaned.slice(12)}`;
    }
    return doc;
  };

  const formatCep = (cep) => {
    if (!cep) return "";
    const cleaned = cep.replace(/\D/g, "");
    if (cleaned.length === 8) {
      return `${cleaned.slice(0, 5)}-${cleaned.slice(5)}`;
    }
    return cep;
  };

  return (
    <div className="quote-customer-card">
      <div className="quote-customer-header">
        <Icon icon="mdi:account" className="card-icon" />
        <h2 className="card-title">Informações do Cliente</h2>
      </div>

      <div className="quote-customer-content">
        <div className="customer-info-grid">
          {customer.name && (
            <div className="customer-info-item">
              <Icon icon="mdi:account-outline" className="info-icon" />
              <div className="info-content">
                <span className="info-label">Nome</span>
                <span className="info-value">{customer.name}</span>
              </div>
            </div>
          )}

          {customer.document && (
            <div className="customer-info-item">
              <Icon icon="mdi:card-account-details-outline" className="info-icon" />
              <div className="info-content">
                <span className="info-label">CPF/CNPJ</span>
                <span className="info-value">
                  {formatDocument(customer.document)}
                </span>
              </div>
            </div>
          )}

          {customer.email && (
            <div className="customer-info-item">
              <Icon icon="mdi:email-outline" className="info-icon" />
              <div className="info-content">
                <span className="info-label">Email</span>
                <span className="info-value">{customer.email}</span>
              </div>
            </div>
          )}

          {customer.phone_number && (
            <div className="customer-info-item">
              <Icon icon="mdi:phone-outline" className="info-icon" />
              <div className="info-content">
                <span className="info-label">Telefone</span>
                <span className="info-value">
                  {formatPhone(customer.phone_number)}
                </span>
              </div>
            </div>
          )}

          {customer.mobile_number && (
            <div className="customer-info-item">
              <Icon icon="mdi:cellphone" className="info-icon" />
              <div className="info-content">
                <span className="info-label">Celular</span>
                <span className="info-value">
                  {formatPhone(customer.mobile_number)}
                </span>
              </div>
            </div>
          )}

          {address && (
            <>
              <div className="customer-info-item full-width">
                <Icon icon="mdi:map-marker" className="info-icon" />
                <div className="info-content">
                  <span className="info-label">Endereço</span>
                  <span className="info-value">
                    {address.street}, {address.number}
                    {address.complement && ` - ${address.complement}`}
                  </span>
                </div>
              </div>

              <div className="customer-info-item">
                <Icon icon="mdi:home-city" className="info-icon" />
                <div className="info-content">
                  <span className="info-label">Bairro</span>
                  <span className="info-value">{address.district}</span>
                </div>
              </div>

              <div className="customer-info-item">
                <Icon icon="mdi:city" className="info-icon" />
                <div className="info-content">
                  <span className="info-label">Cidade/Estado</span>
                  <span className="info-value">{address.city} - {address.state}</span>
                </div>
              </div>

              <div className="customer-info-item">
                <Icon icon="mdi:mailbox" className="info-icon" />
                <div className="info-content">
                  <span className="info-label">CEP</span>
                  <span className="info-value">{formatCep(address.cep)}</span>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default QuoteCustomerInfo;
